import { MyTooltip } from 'components/MyTooltip'

export interface ApprovedChargesCardDisplayProps {
  medicareApprovedCharges: string
  medicareApprovedInfo?: string
}

/**
 * Display for claims approved charges info when appearing on the claims card
 *
 * @param props
 * @returns span if approved info is undefined, otherwise a tooltip
 */
export const ApprovedChargesCardDisplay: React.FC<ApprovedChargesCardDisplayProps> = ({
  medicareApprovedCharges,
  medicareApprovedInfo
}) => {
  if (!medicareApprovedInfo) {
    return <span>{medicareApprovedCharges}</span>
  }

  return (
    <MyTooltip
      title={<div dangerouslySetInnerHTML={{ __html: medicareApprovedInfo }} />}
      className='ds-c-tooltip__trigger-link'
    >
      {medicareApprovedCharges}
    </MyTooltip>
  )
}
